import HeadsAndTails from "./pages/universalCasino/HeadsAndTails";
import LuckyZeroToNine from "./pages/universalCasino/LuckyZeroToNine";
import React, { useEffect } from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Wrapper from "./components/Wrapper";
import Profile from "./pages/Profile";
import Sports from "./pages/Sports";
import { Route, Routes } from "react-router-dom";
import InPlay from "./pages/InPlay";
import CricketBet from "./pages/CricketBet";
import { QueryClient, QueryClientProvider } from "react-query";
import { Toaster } from "react-hot-toast";
import Home from "./pages/Home";
import { useSelector } from "react-redux";
import store, { saveState } from "./redux/store";
import "./App.css";
import SoccerBet from "./pages/SoccerBet";
import TennisBet from "./pages/TennisBet";
import CurrentBets from "./pages/CurrentBets";
import Account from "./pages/Account";
import MyProfile from "./pages/MyProfile";
import AccountStatement from "./pages/AccountStatement";
import BetHistory from "./pages/BetHistory";
import ProfitLoss from "./pages/ProfitLoss";
import ActivityLog from "./pages/ActivityLog";
import Settings from "./pages/Settings";
import PasswordHistory from "./pages/PasswordHistoy";
import RollingCommision from "./pages/RollingCommision";
import MultiMarket from "./pages/MultiMarket";
import MuflisTeenPatti from "./pages/universalCasino/MuflisTeenPatti";
import OneDayTeenPatti from "./pages/universalCasino/1DayTeenPatti";
import GenericBackOnlyCasino from "./pages/universalCasino/GenericBackOnlyCasino";
import GenericPoker from "./pages/universalCasino/GenericPoker";
import BaccaratGeneric from "./pages/universalCasino/BaccaratGeneric";
import GenericBackOnlyDistributedCasino from "./pages/universalCasino/GenericBackOnlyDistributed";
import FastDragonTiger from "./pages/universalCasino/FastDragonTiger";
import DTL from "./pages/universalCasino/DTL";
import OneDayDT from "./pages/universalCasino/1DayDT";
import AndarBahar from "./pages/universalCasino/AndarBahar";
import ThreeCardJ from "./pages/universalCasino/ThreeCardJ";
import CasinoWar from "./pages/universalCasino/CasinoWar";
import AmarAkhbarAnthony from "./pages/universalCasino/AmarAkhbarAnthony";
import BollywoodCasino from "./pages/universalCasino/BollywoodCasino";
import SportWiseProfitLoss from "./pages/SportWiseProfitLoss";
import EventIdWiseProfitLoss from "./pages/EventIdWiseProfitLoss";
import MarketIdWiseProfitLoss from "./pages/MarketIdWiseProfitLoss";
import UserIdWiseProfitLoss from "./pages/UserIdWiseProfitLoss";
import BallByBall from "./pages/BallByBall/BallByBall";
import Vimaan from "./pages/Vimaan";

function App() {
  const userData = useSelector((state) => state.account.userData);
  const [queryClient] = React.useState(() => new QueryClient());
  useEffect(() => {
    store.subscribe(() => {
      saveState(store.getState());
    });
  }, []);
  useEffect(() => {
    var checkForAutoLoginFlag = localStorage.getItem("checkForAutoLoginFlag");
    if (checkForAutoLoginFlag) {
      localStorage.setItem(
        "checkForAutoLoginFlag",
        String(parseInt(checkForAutoLoginFlag) + 1)
      );
    }
    if (parseInt(checkForAutoLoginFlag) > 1) {
      localStorage.removeItem("checkForAutoLoginFlag");
    }
  }, [userData?.token]);

  return (
    <QueryClientProvider client={queryClient}>
      <Wrapper>
        <div style={{ zIndex: 100000 }}>
          <Toaster />
        </div>
        {userData?.token ? (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nav/:game" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/account" element={<Account />} />
            <Route path="/profit-loss" element={<ProfitLoss />} />
            <Route path="/game/cricket/ball-by-ball" element={<BallByBall />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/activity-log" element={<ActivityLog />} />
            <Route path="/inplay" element={<InPlay />} />
            <Route path="/vimaan" element={<Vimaan />} />
            <Route path="/bet-history" element={<BetHistory />} />
            <Route path="/account-statement" element={<AccountStatement />} />
            <Route path="/myprofile" element={<MyProfile />} />
            <Route path="/game/cricket/:id" element={<CricketBet />} />
            <Route path="/game/soccer/:id" element={<SoccerBet />} />
            <Route path="/game/tennis/:id" element={<TennisBet />} />
            <Route path="/current_bets" element={<CurrentBets />} />
            <Route path="/password-history" element={<PasswordHistory />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/allsport-highlight/:id" element={<Home />} />
            <Route path="/rolling-commission" element={<RollingCommision />} />
            <Route path="/multimarket" element={<MultiMarket />} />
            <Route
              path="/casino/UNI_3_CARD_JUDGMENT_A"
              element={<ThreeCardJ />}
            />
            <Route
              path="/casino/generic/:id"
              element={<GenericBackOnlyCasino />}
            />
            <Route
              path="/profitloss/:sport/:startDate/:endDate"
              element={<SportWiseProfitLoss />}
            />
            <Route
              path="/profitloss/:sport/:eventId/:startDate/:endDate"
              element={<EventIdWiseProfitLoss />}
            />
            <Route
              path="/profitloss/:sport/:eventId/:marketId/:startDate/:endDate"
              element={<MarketIdWiseProfitLoss />}
            />
            <Route
              path="/profitloss/:sport/:eventId/:marketId/:userId"
              element={<CurrentBets />}
            />
            <Route path="/casino/UNI_HEADS_AND_TAILS" element={<HeadsAndTails />} />
            <Route path="/casino/UNI_LUCKY_0_TO_9" element={<LuckyZeroToNine />} />
            <Route path="/casino/UNI_CASINO_WAR" element={<CasinoWar />} />
            <Route path="/casino/ab/:id" element={<AndarBahar />} />
            <Route
              path="/casino/UNI_MUFLIS_TEEN_PATTI"
              element={<MuflisTeenPatti />}
            />
            <Route
              path="/casino/UNI_1_DAY_DRAGON_TIGER"
              element={<OneDayDT />}
            />
            {/*  <Route
              path="/casino/UNI_JOKER_TEEN_PATTI"
              element={<JokerTeenPatti />}
            /> */}
            <Route
              path="/casino/poker/generic/:id"
              element={<GenericPoker />}
            />
            <Route path="/casino/fas/:id" element={<FastDragonTiger />} />
            <Route path="/casino/dtl/:id" element={<DTL />} />
            <Route
              path="/casino/baccarat/generic/:id"
              element={<BaccaratGeneric />}
            />
            <Route
              path="/casino/bollywoodCasino"
              element={<BollywoodCasino />}
            />
            <Route
              path="/casino/distributed/back/generic/:id"
              element={<GenericBackOnlyDistributedCasino />}
            />
            <Route
              path="/casino/UNI_1DAY_TEEN_PATTI"
              element={<OneDayTeenPatti />}
            />
            <Route path="/casino/aaa/:id" element={<AmarAkhbarAnthony />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/nav/:game" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<Home />} />
            <Route path="/allsport-highlight/:id" element={<Home />} />
            <Route path="/inplay" element={<InPlay />} />
            <Route path="/vimaan" element={<Vimaan />} />
            <Route path="/game/cricket/:id" element={<CricketBet />} />
            <Route path="/game/soccer/:id" element={<SoccerBet />} />
            <Route path="/game/tennis/:id" element={<TennisBet />} />
            <Route path="/login" element={<Login />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="*" element={<Login />} />
          </Routes>
        )}{" "}
      </Wrapper>
    </QueryClientProvider>
  );
}

export default App;
